import { Component, type ErrorInfo, type ReactNode } from "react";

export class ErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("PWEB render failure", error, info.componentStack);
  }

  render() {
    if (this.state.failed) {
      return (
        <main className="fatal-error">
          <p className="eyebrow">RENDER BOUNDARY</p>
          <h1>The interface could not complete this render.</h1>
          <button className="command-button" onClick={() => window.location.reload()}>Reload PWEB</button>
        </main>
      );
    }
    return this.props.children;
  }
}
